import React, { FunctionComponent } from "react";
import PropTypes from "prop-types";
import ReactTooltip from "react-tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencilAlt } from "@fortawesome/free-solid-svg-icons";
import { EditCategoryButton } from "../../styles/diversity-form-styles";

export interface IEditButtonProps {
  setFieldValue: (
    field: string,
    value: unknown,
    shouldValidate: boolean
  ) => void;
  ethnicGroup: string;
}

export const EditButton: FunctionComponent<IEditButtonProps> = ({
  setFieldValue,
  ethnicGroup,
}) => (
  <>
    <ReactTooltip
      place="bottom"
      type="dark"
      effect="solid"
      aria-haspopup="true"
      id="diversity-form-tooltip"
    />
    <EditCategoryButton
      type="button"
      data-tip="Change"
      data-for="diversity-form-tooltip"
      onClick={() => {
        setFieldValue("ethnicGroup", null, true);
        setFieldValue("ethnicSubgroup", null, true);
      }}
    >
      {ethnicGroup}
      <FontAwesomeIcon icon={faPencilAlt} />
    </EditCategoryButton>
  </>
);

EditButton.propTypes = {
  setFieldValue: PropTypes.func.isRequired,
  ethnicGroup: PropTypes.string,
};

EditButton.defaultProps = {
  ethnicGroup: null,
};

export default EditButton;
